var $6f40c3a58f594b58$exports = {};
const $6f40c3a58f594b58$var$inputRef = document.querySelector("#bookmarkInput");
const $6f40c3a58f594b58$var$listRef = document.querySelector("#bookmarkList");
const $6f40c3a58f594b58$var$btnRef = document.querySelector("#addBookmarkBtn");
const $6f40c3a58f594b58$var$bookArray = JSON.parse(localStorage.getItem("bookmarks"));
$6f40c3a58f594b58$var$renderArray();
$6f40c3a58f594b58$var$btnRef.addEventListener("click", ()=>{
    const urlValue = $6f40c3a58f594b58$var$inputRef.value.trim();
    if (urlValue) {
        $6f40c3a58f594b58$var$bookArray.push(urlValue);
        $6f40c3a58f594b58$var$inputRef.value = "";
        $6f40c3a58f594b58$var$renderArray();
    }
});
function $6f40c3a58f594b58$var$renderArray() {
    const item = $6f40c3a58f594b58$var$bookArray.map((url, index)=>{
        return `<li class="list__item">
        <a href="${url}" class="link">${url}</a>
        <button id="addBookmarkBtn" data-action="${index}">X</button>
    </li>`;
    }).join("");
    localStorage.setItem("bookmarks", JSON.stringify($6f40c3a58f594b58$var$bookArray));
    $6f40c3a58f594b58$var$listRef.innerHTML = item;
}
$6f40c3a58f594b58$var$listRef.addEventListener("click", (event)=>{
    const target = event.target.nodeName;
    const index = event.target.dataset.action;
    if (target !== "BUTTON") return;
    $6f40c3a58f594b58$var$bookArray.splice(index, 1);
    $6f40c3a58f594b58$var$renderArray();
});
//-------------------------------
const $6f40c3a58f594b58$var$btnEl = document.querySelector("#saveBtn");
const $6f40c3a58f594b58$var$form = document.querySelector(".form");
const $6f40c3a58f594b58$var$formFields = $6f40c3a58f594b58$var$form.elements;
$6f40c3a58f594b58$var$btnEl.addEventListener("click", (event)=>{
    localStorage.clear();
    event.preventDefault();
});
for(let i = 0; i < $6f40c3a58f594b58$var$formFields.length; i += 1)$6f40c3a58f594b58$var$formFields[i].addEventListener("change", $6f40c3a58f594b58$var$changeHandler);
function $6f40c3a58f594b58$var$changeHandler() {
    localStorage.setItem(this.name, this.value);
}
function $6f40c3a58f594b58$var$checkStorage() {
    for(let i = 0; i < $6f40c3a58f594b58$var$formFields.length; i += 1)if ($6f40c3a58f594b58$var$formFields[i].type !== "submit") {
        const saved = localStorage.getItem($6f40c3a58f594b58$var$formFields[i].name);
        if (saved !== null) $6f40c3a58f594b58$var$formFields[i].value = saved;
    }
}
$6f40c3a58f594b58$var$checkStorage();


//# sourceMappingURL=hwjs25.73165593.js.map
